import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Clock, LayoutTemplate, EyeOff } from 'lucide-react';
const stats = [{
  icon: <Clock size={24} className="text-blue-500" data-id="element-275" />,
  title: "Your site loads in 8s. Your competitor's loads in 1.2s.",
  description: "Every second of delay drops conversion rates by 7%. Speed is no longer a luxury; it's the baseline of trust."
}, {
  icon: <AlertTriangle size={24} className="text-blue-500" data-id="element-276" />,
  title: '94% of first impressions are design-related.',
  description: 'If your site looks like it was built in 2015, prospects assume your solutions are equally outdated.'
}, {
  icon: <LayoutTemplate size={24} className="text-blue-500" data-id="element-277" />,
  title: 'Generic templates = generic results.',
  description: "Using the same $50 theme as 10,000 other businesses guarantees you'll be treated like a commodity."
}, {
  icon: <EyeOff size={24} className="text-blue-500" data-id="element-278" />,
  title: 'The cost of blending in? Invisibility.',
  description: "A digital brochure generates zero noise. Without authority-driven content, you're just another URL."
}];
export function StatusQuoSection() {
  return <section className="py-24 md:py-32 bg-[#0A0A0A] relative border-t border-white/5" data-id="element-279">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-280">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16 md:mb-24" data-id="element-281">
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-282">
            The Status Quo Is Costing You.
          </h2>
          <p className="text-xl text-neutral-400 max-w-2xl" data-id="element-283">
            Most websites are just "digital brochures" that generate zero noise.
            In 2024, being generic is the most expensive mistake a business can
            make.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-284">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#111111] border border-white/5 p-8 rounded-sm hover:border-white/10 transition-colors group" data-id="element-285">
              <div className="w-12 h-12 bg-blue-500/10 rounded-sm flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-286">
                {stat.icon}
              </div>
              <h3 className="font-display text-xl font-semibold text-white mb-3" data-id="element-287">
                {stat.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-288">
                {stat.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}